export default __webpack_public_path__ + "static/media/astronomy.8228d934.webp";